import axios from "axios";
import {
  toast
} from "react-toastify";
import {
  push
} from "connected-react-router";

export const USER_GET_USERS_REQUEST = "USER_GET_USERS_REQUEST";
export const USER_GET_USERS_SUCCESS = "USER_GET_USERS_SUCCESS";
export const USER_GET_USERS_FAIL = "USER_GET_USERS_FAIL";
export const getUsers = params => dispatch => {
  dispatch({
    type: USER_GET_USERS_REQUEST
  });
  axios
    .request({
      url: "dashboard/users",
      params: params,
      method: "GET"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: USER_GET_USERS_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: USER_GET_USERS_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const USER_GET_USER_REQUEST = "USER_GET_USER_REQUEST";
export const USER_GET_USER_SUCCESS = "USER_GET_USER_SUCCESS";
export const USER_GET_USER_FAIL = "USER_GET_USER_FAIL";
export const getUser = id => dispatch => {
  dispatch({
    type: USER_GET_USER_REQUEST
  });
  axios
    .request({
      url: "users/" + id,
      method: "get"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: USER_GET_USER_SUCCESS,
          user: data.data,
          msg: data.message
        });
      } else {
        dispatch({
          type: USER_GET_USER_FAIL,
          errors: data.errors ? data.errors : {},
          msg: data.message
        });
        // toast.warn(data.message);
      }
    });
};

export const USER_GET_PROFILE_REQUEST = "USER_GET_PROFILE_REQUEST";
export const USER_GET_PROFILE_SUCCESS = "USER_GET_PROFILE_SUCCESS";
export const USER_GET_PROFILE_FAIL = "USER_GET_PROFILE_FAIL";
export const getProfile = type => dispatch => {
  dispatch({
    type: USER_GET_PROFILE_REQUEST
  });
  axios
    .request({
      url: "dashboard/profile",
      method: "get"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: USER_GET_PROFILE_SUCCESS,
          user: data.data,
          msg: data.message
        });
        if ((type === "user" || type === "auth") && data.data.role.id < 600) {
          dispatch(push("/dash/admin/users"));
        } else if ((type === "admin" || type === "auth") && data.data.role.id >= 600) {
          dispatch(push("/dash/user/profile"));
        }
      } else {
        dispatch({
          type: USER_GET_PROFILE_FAIL,
          errors: data.errors ? data.errors : {},
          msg: data.message
        });
        // toast.warn(data.message);
      }
    });
};

export const USER_EDIT_PROFILE_REQUEST = "USER_EDIT_PROFILE_REQUEST";
export const USER_EDIT_PROFILE_SUCCESS = "USER_EDIT_PROFILE_SUCCESS";
export const USER_EDIT_PROFILE_FAIL = "USER_EDIT_PROFILE_FAIL";
export const editProfile = ({
  name,
  pseudonym,
  email,
  phone,
  original_password,
  new_password,
  new_password_confirmation,
  avatar,
  type
}) => dispatch => {
  dispatch({
    type: USER_EDIT_PROFILE_REQUEST
  });
  var setting = {
    url: "dashboard/profile/edit",
    params: {
      name,
      pseudonym,
      email,
      phone,
      original_password,
      new_password,
      new_password_confirmation
    },
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  if (type === "avatar") {
    let params = new FormData();
    if (avatar) {
      params.append("image", avatar);
    }
    setting = {
      url: "dashboard/profile/edit/pic",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
  }

  axios.request(setting).then(({
    data
  }) => {
    if (data.success) {
      dispatch({
        type: USER_EDIT_PROFILE_SUCCESS,
        msg: data.message,
        data: data.data
      });
      dispatch(getProfile());
    } else {
      dispatch({
        type: USER_EDIT_PROFILE_FAIL,
        msg: data.message,
        errors: data.errors ? data.errors : {}
      });
      // toast.warn(data.message);
    }
  });
};

export const USER_EDIT_SUB_REQUEST = "USER_EDIT_SUB_REQUEST";
export const USER_EDIT_SUB_SUCCESS = "USER_EDIT_SUB_SUCCESS";
export const USER_EDIT_SUB_FAIL = "USER_EDIT_SUB_FAIL";
export const editSub = ({
  subscription
}) => dispatch => {
  let category_names = [];
  Object.keys(subscription).forEach(function (item) {
    if (subscription[item]) {
      category_names.push(item);
    } // value
  });
  dispatch({
    type: USER_EDIT_PROFILE_REQUEST
  });
  axios
    .request({
      url: "dashboard/subscription/customize",
      params: {
        category_names
      },
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: USER_EDIT_PROFILE_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: USER_EDIT_PROFILE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const USER_REMOVE_USER_REQUEST = "USER_REMOVE_USER_REQUEST";
export const USER_REMOVE_USER_SUCCESS = "USER_REMOVE_USER_SUCCESS";
export const USER_REMOVE_USER_FAIL = "USER_REMOVE_USER_FAIL";
export const removeUser = user_id => dispatch => {
  dispatch({
    type: USER_REMOVE_USER_REQUEST
  });
  axios
    .request({
      url: "users/" + user_id,
      method: "DELETE"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: USER_REMOVE_USER_SUCCESS
        });
        toast.success(data.message);
        dispatch(push("/dash/users"));
      } else {
        dispatch({
          type: USER_REMOVE_USER_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const USER_ASSIGN_ROLE_REQUEST = "USER_ASSIGN_ROLE_REQUEST";
export const USER_ASSIGN_ROLE_SUCCESS = "USER_ASSIGN_ROLE_SUCCESS";
export const USER_ASSIGN_ROLE_FAIL = "USER_ASSIGN_ROLE_FAIL";
export const assignRole = ({
  user_id,
  role_id
}) => dispatch => {
  dispatch({
    type: USER_ASSIGN_ROLE_REQUEST
  });
  axios
    .request({
      url: `dashboard/user/edit`,
      method: "POST",
      data: {
        user_id,
        role_id
      }
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: USER_ASSIGN_ROLE_SUCCESS,
          msg: data.message
        });
        toast.success(data.message);
        dispatch(push("/dash/admin/users"));
      } else {
        dispatch({
          type: USER_ASSIGN_ROLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};